import { NavigationItemDirection, NavigationPosition } from '@unifyapps/defs/types/interface';
import {
  type NavApplicationItemType,
  type NavItem,
  type NavItemGroup,
  NavigationItemLabelVariantEnum,
  NavigationItemSelectionVariantEnum,
} from './types';

export const isSelectionVariantSolid = (selectionVariant: NavigationItemSelectionVariantEnum) => {
  return selectionVariant === NavigationItemSelectionVariantEnum.Solid;
};

export const isSelectionVariantStroke = (selectionVariant: NavigationItemSelectionVariantEnum) => {
  return selectionVariant === NavigationItemSelectionVariantEnum.Stroke;
};

export const isLabelVariantUpfront = (labelVariant: NavigationItemLabelVariantEnum) => {
  return labelVariant === NavigationItemLabelVariantEnum.Upfront;
};

export const isLabelVariantExpandable = (labelVariant: NavigationItemLabelVariantEnum) => {
  return labelVariant === NavigationItemLabelVariantEnum.Expandable;
};

export const isPlatformSideNav = (labelVariant?: NavigationItemLabelVariantEnum) => {
  return labelVariant === NavigationItemLabelVariantEnum.Platform;
};

export const isTopNavigation = (position?: NavigationPosition) => {
  return position === NavigationPosition.Top;
};

export const hasSubnavigationItems = (item: NavItemGroup | NavItem | NavApplicationItemType) => {
  return 'items' in item && item.items.length > 0;
};

// a group is "active" when any descendant leaf (at ANY depth) is the active nav item, so the whole
// ancestor path highlights. Shared by the expanded-rail NavigationSubItem and the collapsed-rail
// flyout so both agree on selection across n levels of nesting.
export const groupContainsActiveNavItem = (
  group: NavItemGroup,
  activeNavItemId?: string,
): boolean =>
  group.items.some((child) =>
    child.type === 'GROUP'
      ? groupContainsActiveNavItem(child, activeNavItemId)
      : child.id === activeNavItemId,
  );

export const isHorizontalUpfrontFn = (
  labelVariant?: NavigationItemLabelVariantEnum,
  selectionVariant?: NavigationItemSelectionVariantEnum,
  direction?: NavigationItemDirection,
) => {
  return (
    direction === NavigationItemDirection.Row &&
    labelVariant === NavigationItemLabelVariantEnum.Upfront &&
    selectionVariant === NavigationItemSelectionVariantEnum.Solid
  );
};
